var _defs, _path, _polygon, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew336({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,4.37a5,5,0,0,0-5,5H13A5,5,0,0,0,8,4.37Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "12.45 3.4 11.51 3.4 4.49 3.4 3.55 3.4 0.5 12.6 7.54 12.6 8.46 12.6 15.5 12.6 12.45 3.4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.19,
    y1: 9.38,
    x2: 6.19,
    y2: 12.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.81,
    y1: 9.38,
    x2: 9.81,
    y2: 12.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew336);
export default __webpack_public_path__ + "static/media/Symbolpack_New_336.795fc028df9662d26736037d81ae4c42.svg";
export { ForwardRef as ReactComponent };